/**
 * @module KUP
 */
(function ($) {

    'use strict';

    if (typeof KUP === 'undefined') {
        return null;
    }

    /**
     * Example module
     *
     * @class KUP.AllowExtendContent
     */
    var AllowExtendContent = (function() {

        /**
         * Reference on the container
         *
         * @private
         * @property container
         * @type {Object}
         */
        var container;

        /**
         * Initialization of the module
         *
         * @method init
         * @example
         *
         *      <div id="example-container">...</div>
         */

        function init() {
          container = $('.allow-extend-content');
          try {
            if (drupalSettings) {
              if (drupalSettings.kup_custom.custom_consent_video || drupalSettings.kup_custom.custom_consent_map) {
                if (container.length) {
                  initListener();
                }
              }
            }
          }
          catch(e) {}
        }

        /**
         * Register Listener
         *
         * @private
         * @method initListener
         */
        function initListener() {
          container.each(function() {
            var allowExtendContent = $(this),
                allowOne = allowExtendContent.find('.allow-one'),
                allowAll = allowExtendContent.find('.allow-all'),
                allowId = allowExtendContent.attr('data-id'),
                allowType = allowExtendContent.attr('data-type'),
                allowData = allowExtendContent.attr('data-data'),
                allowOneCookie = 'allowone-' + allowType + '-' + allowId,
                allowAllCookie = 'allowall-' + allowType;

            if( Cookies.get(allowOneCookie) == 1 || Cookies.get(allowAllCookie) == 1 ) {
              showContent(allowExtendContent, allowData, allowType, allowOneCookie, allowId);
            }

            // unbind in case listeners get reinited
            allowOne.unbind();
            allowAll.unbind();

            allowOne.on('change', function() {
              showContent(allowExtendContent, allowData, allowType, false, allowId);
              // showContent(allowExtendContent, allowData, allowType, allowOneCookie, allowId);
            });

            allowAll.on('change', function() {
              showContent(allowExtendContent, allowData, allowType, allowAllCookie);
            });
          });
        }

      /**
       * Shows content
       *
       * @private
       * @method showContent
       */
        function showContent(allowExtendContent, allowData, allowType, allowCookie = false, allowId = '') {
          if(allowCookie) {
            Cookies.set(allowCookie, 1);
          }

          switch(allowType) {
            case 'youtube':
            case 'vimeo':
              if (allowId == '') {
                $('.section--video').each(function() {
                  var src = $(this).find('.allow-extend-content').attr('data-data');
                  $(this).find('.section--video--wrapper iframe').attr('src', src);
                  $(this).find('.allow-extend-content').fadeOut();
                });
              }
              else {
                allowExtendContent.parent().find('iframe').attr('src', allowData);
              }
              break;

            case 'googlemap':
              KUP.GoogleMaps.initConsentMaps(allowId);
              break;
          }

          allowExtendContent.parent().css('minHeight', 'unset');
          allowExtendContent.hide();
        }

        /**
         * @return Public-API
         */
        return {
            init : init
        };

    }());

    /**
     *
     * @for KUP
     * @property Example
     * @type {Function}
     */
    KUP.AllowExtendContent = AllowExtendContent;

    return AllowExtendContent;

}(jQuery));
